'use strict';

/** @type {import('./Reflect.getPrototypeOf')} */
module.exports = (typeof Reflect !== 'undefined' && Reflect.getPrototypeOf) || null;



//////////////////
// WEBPACK FOOTER
// ./~/_get-proto@1.0.1@get-proto/Reflect.getPrototypeOf.js
// module id = kotw
// module chunks = 0